import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users'
import messages from './modules/messages'
import misc from './modules/misc'
import room from './modules/room'
import websocket from './modules/websocket'

Vue.use(Vuex);

const state = {}
const getters = {}
const mutations = {}

const actions = {
    resetStore(context) {
        context.commit('setMyId', undefined)
        context.commit('truncateMessagesList')
        context.commit('truncateUsersList')
    }
}

export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations,
    modules: {
        users: users,
        messages: messages,
        misc: misc,
        room: room,
        websocket: websocket
    }
})
